export default "__VITE_ASSET__CB4XXyBT__"